import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@mui/material';

const labels = {
  title: 'Name/Title',
  description: 'Description',
  custom_cta: 'Button Text',
};

const placeholder = {
  title: 'Name/Title',
  description: 'Bio/Description',
};

const TextEditor = ({name, value, onChange}) => {
  
  return (
    <TextField
      color="warning"
      name={name}
      label={labels[name]}
      value={value}
      onChange={onChange}
      fullWidth
      variant="outlined"
      size='small'
      placeholder={placeholder[name]}
      multiline={name === 'description'}
      rows={name === 'description' ? 4 : 1}
      sx={{ mb: 2 }}
    />
  );
};

TextEditor.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default TextEditor;